import {formatCurrency, parseCurrency} from "../../utils/i18n";
import PropTypes from 'prop-types';
import React from 'react';
import ManagedResourceList from '../shared/ManagedResourceList';
import './styles/payments.scss';

export default class FeeList extends React.Component {
  static propTypes = {
    fees: PropTypes.arrayOf(PropTypes.shape({
      description: PropTypes.string.isRequired, // Description of each fee, i.e. "tuition"
      amount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]) // Either a number representing amount in dollars (i.e. 1.05), or a string that's already formatted (but will be parsed and re-formatted) i.e. "$1.05"
    })).isRequired,
    totalDescription: PropTypes.string, // Description to use for total amount due
    displayType: PropTypes.string, // Type of things being listed, i.e. "fees" or "charges".  Defaults to "charges"?
    className: PropTypes.string // If this row gets a specific class
  };

  static defaultProps = {
    totalDescription: 'Total Amount Due',
    displayType: 'charges',
  };

  total() {
    const {fees} = this.props;

    const amounts = fees.map(fee => parseCurrency(fee.amount || 0));

    return amounts.reduce((sum, x) => sum + x);
  }

  items() {
    const {fees} = this.props;

    const filtered = fees.filter(x=>!!x);

    if(filtered.length <= 1) {
      return filtered;
    }
    else {
      return [
        ...filtered,
        {
          description: this.props.totalDescription,
          amount: this.total(),
          className: 'fees-total'
        }
      ]
    }
  }

  render() {
    return <div className={'fee-list'}>
      <ManagedResourceList
        items={this.items()}
        fetchItems={() => {}}
        displayType={this.props.displayType}
        columns={[
          {value: 'description'},
          {
            value: (item) => formatCurrency(item.amount),
            className: ()=>'fee-amount text-end'
          }
        ]}
        rowClassName={item => item.className}
        collectionButtons={[]}
        itemButtons={[]}
        className={'fee-list'}
      />
    </div>;
  }
}